import React, { useContext, useMemo } from 'react';
import { any, arrayOf, node } from 'prop-types';
import _ from 'underscore';

export const PivotImageEditorContext = React.createContext({
  selectionIds: [],
});

export const PivotImageEditorContextProvider = ({
  children, selection,
}) => {
  const value = useMemo(() => ({
    selectionIds: _.compact(selection.map(s => s.id || s.Id)),
  }), [selection]);

  return (
    <PivotImageEditorContext.Provider value={value}>
      {children}
    </PivotImageEditorContext.Provider>
  );
};

PivotImageEditorContextProvider.propTypes = {
  children: node.isRequired,
  selection: arrayOf(any),
};

PivotImageEditorContextProvider.defaultProps = {
  selection: [],
};

export const usePivotImageEditorContext = () => useContext(PivotImageEditorContext);
